// removed by extract-text-webpack-plugin
module.exports = {"modal-overlay":"_2U3GZxhGjrwKKdZHs7LqPU","modal-content":"_1hHpRKn-791a_gABHi1NZj"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/Modal.styl
// module id = 468
// module chunks = 0